<template>
    <div>
        <PageBanner :pageTitle="$t('our_team_stamoulis')" />
        <Stamoulis />
    </div>
</template>

<script>
import PageBanner from '../Common/PageBanner'
import Stamoulis from '../OurTeam/Stamoulis.vue';

export default {
    components: {
        PageBanner,
        Stamoulis,
    }
}
</script>
